/**
 * Scroll Animations using GSAP ScrollTrigger
 */

export class ScrollAnimations {
  constructor() {
    this.init();
  }

  /**
   * Initialize animations
   */
  init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('GSAP or ScrollTrigger not loaded');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    this.fadeInElements();
    this.slideInElements();
  }

  /**
   * Fade in elements on scroll
   */
  fadeInElements() {
    const elements = document.querySelectorAll('.fade-in');

    elements.forEach((element) => {
      gsap.from(element, {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });
    });
  }

  /**
   * Slide in elements on scroll
   */
  slideInElements() {
    const elements = document.querySelectorAll('.slide-in');

    elements.forEach((element) => {
      gsap.from(element, {
        x: -100,
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });
    });
  }
}
